import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { findeMitarbeiter } from './util.js';
import { erstelleZeitblockTabelle, neuesZeitblockObjekt, offenerZeitblock } from './zeitblock.js';
import {
	erstellePostenSelect,
	erstelleQualifikationSelect,
	erstelleSchichtVorlageSelect,
	erstelleToolbarVorlagenSelect,
	zeigeNeueSchicht,
    } from './dienstplan.js';

// Relevante HTML Elemente auf die oft zugegriffen wird
const modal = document.getElementById('my-modal');
const schichtInputTemplate = document.querySelector('[template-schicht-input]');

/**
 * Erstellt die HTML Input Felder für die Schicht, der "type" Parameter hilft erstellen (0) und editieren (1) zu differenzieren
 * @param {object} schicht Schichtobjekt
 * @param {int} type
 * @param {string} gridId zeigt auf das Grid Element für die Schicht.
 */
 async function erstelleSchichtInputFeld(schicht, type, gridId) {
	const mitarbeiter = await stammdatenService.getMitarbeiter();
	const mitarbeiterObj = findeMitarbeiter(mitarbeiter, schicht.MitarbeiterID);
	const postenListe = await stammdatenService.getPosten();
	const qualifikationen = await stammdatenService.getQualifikationen();

	// Reset des Modals
	const modalText = document.getElementById('modal-text');
	modalText.innerHTML = '';
	// Kopieren des Templates
	const inputFeld = schichtInputTemplate.content.cloneNode(true).children[0];
	// Titel und Untertitel mit Name und Datum
	inputFeld.querySelector('#input-tag').innerText = dayjs(schicht.Datum).format('dd.');
	inputFeld.querySelector('#input-datum').innerText = dayjs(schicht.Datum).format('DD.MM.YYYY');
	inputFeld.querySelector('#input-name').innerText = `${mitarbeiterObj.Personalien.Nachname}, ${mitarbeiterObj.Personalien.Vorname}`;

	// Auswahl der Vordefinierten Schichten
	let inputDiv = inputFeld.querySelector('#input-vorlagen');
	const vorlageSelect = await erstelleSchichtVorlageSelect(false, type == 1);
	inputDiv.appendChild(vorlageSelect);

	// Auswahl des Postens
	inputDiv = inputFeld.querySelector('#input-posten-div');
	const postenSelect = await erstellePostenSelect(postenListe, schicht.PostenID);
	inputDiv.appendChild(postenSelect);

	// Auswahl der Qualifikation
	inputDiv = inputFeld.querySelector('#input-qualifikationen');
	mitarbeiterObj.Beschaeftigung[0].Verguetung.sort((a, b) => b.IstStandardQualifikation - a.IstStandardQualifikation);
	const qualiSelect = await erstelleQualifikationSelect(qualifikationen, mitarbeiterObj.Beschaeftigung[0].Verguetung, schicht.QualifikationID);
	inputDiv.appendChild(qualiSelect);
	// Input für ganztags
	const inputGanztags = inputFeld.querySelector('#input-schicht-ganztags');
	// Input für offener Beginn
	const inputOffenerBeginn = inputFeld.querySelector('#input-schicht-offener-beginn');
	inputOffenerBeginn.checked = schicht.OffenerBeginn ? schicht.OffenerBeginn : false;
	inputOffenerBeginn.addEventListener('input', () => {
		if (!inputOffenerBeginn.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputOffenerBeginn.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, false, mitarbeiterObj);
		}
	});
	// Input für offenes Ende
	const inputOffenesEnde = inputFeld.querySelector('#input-schicht-offenes-ende');
	inputOffenesEnde.checked = schicht.OffenesEnde ? schicht.OffenesEnde : false;
	inputOffenesEnde.addEventListener('input', () => {
		if (!inputOffenesEnde.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputOffenesEnde.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, true, mitarbeiterObj);
		}
	});


	inputGanztags.checked = schicht.Ganztags ? schicht.Ganztags : false;
	inputGanztags.addEventListener('input', () => {
		if (inputGanztags.checked) {
			inputOffenerBeginn.checked = true;
			inputOffenesEnde.checked = true;
		}
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputGanztags.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, false, mitarbeiterObj, true);
		}
	});

	// Falls es eine Farbe/Notiz schon gibt, auswählen, sonst Standard value.
	inputFeld.querySelector('#input-schicht-farbe').value = schicht.SchichtFarbe ? schicht.SchichtFarbe : '#0071bd';
	inputFeld.querySelector('#input-schicht-notiz').value = schicht.SchichtNotiz ? schicht.SchichtNotiz : '';

	// Titel anzeigen falls vorhanden
	if (schicht.Titel) {
		inputFeld.querySelector('#input-schicht-titel').value = schicht.Titel;
	}

	// Zeige das befüllte Input Feld an
	modalText.appendChild(inputFeld);

	const sumbitBtn = inputFeld.querySelector('#input-submit');
	sumbitBtn.addEventListener('click', () => updateSchichtHandler(schicht, type, gridId));
	const deleteBtn = inputFeld.querySelector('#input-delete');
	if (schicht._id) {
		deleteBtn.addEventListener('click', async (event) => window.fun.schichtEntfernen(schicht._id, event, gridId));
	} else {
		deleteBtn.addEventListener('click', async () => closeModal());
	}

	modal.style.display = 'block';
	// Erstelle Zeitblock Input
	erstelleZeitblockTabelle(schicht, type);
}

/**
 * Hier sollen die Informationen der neuen Dienstzeiten aufgenommen werden und and die DB gesendet werden.
 * @param {object} schicht
 * @param {int} type entscheidet ob erstellen (0) oder editieren (1)
 * @param {string} gridId zeigt auf das Grid Element für die Schicht.
 */
 async function updateSchichtHandler(schicht, type, gridId) {
	schicht = sammleSchichtDaten(schicht);
	if (!schicht.Ganztags && _.isEqual(schicht.SchichtVon, schicht.SchichtBis)) {
		zeigeKleineNachricht('Schicht kann nicht am gleichen Zeitpunkt beginnen und enden!', 0);
		return;
	}

	// Eine neue Schicht soll den Zeittyp 2 für Dienstplan bekommen und keine SchichtID besitzen
	if (type === 0 || schicht.ZeitTyp === 8) {
		delete schicht._id;
		schicht.ZeitTyp = 2;
	}

	const schichtNeu = await schichtenService.updateSchichtObjekt(schicht);
	if (schichtNeu) {
		await zeigeNeueSchicht(schichtNeu, gridId);
		zeigeKleineNachricht('Die Schicht konnte erfolgreich eingefügt werden!', 1);
	}
	closeModal();
}

function sammleSchichtDaten(schicht, isVorlage = false) {
    // Qualifikation und Posten brauchen wir nicht für die schichtvorlage
    if (!isVorlage) {
		const qualSelect = document.getElementById('input-qualifikation');
        schicht.QualifikationID = qualSelect.value;
        schicht.Qualifikation = qualSelect.children[qualSelect.selectedIndex].innerText;
		const postenSelect = document.getElementById('input-posten-select');
		schicht.PostenID = postenSelect.value;
		schicht.Posten = postenSelect.children[postenSelect.selectedIndex].innerText;
    }
	const betriebSelect = document.getElementById('select-betriebsstaette');
	schicht.BetriebsstaetteID = betriebSelect.value;
	const bereichSelect = document.getElementById('bereich-select');
	schicht.BereichID = bereichSelect.value;
	schicht.Bereich = bereichSelect[bereichSelect.selectedIndex].innerText;

	schicht.OffenerBeginn = document.getElementById('input-schicht-offener-beginn').checked;
	schicht.OffenesEnde = document.getElementById('input-schicht-offenes-ende').checked;
	schicht.Ganztags = document.getElementById('input-schicht-ganztags').checked;
	schicht.SchichtFarbe = document.getElementById('input-schicht-farbe').value;
	schicht.SchichtNotiz = document.getElementById('input-schicht-notiz').value;
	const table = document.getElementById('zeiten-tabelle');

	// Setze die Zeitblöcke zurück, damit beim Löschen einzelner Zeilen keine Inkonsistenzen auftreten
	schicht.Zeitbloecke = [];
	for (let i = 1; i <= table.rows.length - 1; i += 1) {
		schicht.Zeitbloecke[i - 1] = neuesZeitblockObjekt();
		schicht.Zeitbloecke[i - 1].BlockVon = document.getElementById(`${i}:von`).value;
		schicht.Zeitbloecke[i - 1].BlockBis = document.getElementById(`${i}:bis`).value;
		schicht.Zeitbloecke[i - 1].EgfzID = parseInt(document.getElementById(`${i}:egfz`).value, 10);
		if (schicht.Zeitbloecke[i - 1].BlockVon == '' || schicht.Zeitbloecke[i - 1].BlockBis == '') {
			zeigeKleineNachricht('Bitte vollständige Von-Bis Uhrzeiten eingeben!', 0);
			return;
		}
	}
	schicht.SchichtVon = schicht.Zeitbloecke[0].BlockVon;
	schicht.SchichtBis = schicht.Zeitbloecke[schicht.Zeitbloecke.length - 1].BlockBis;
	schicht.Datum = dayjs(schicht.Datum).tz().format('YYYY-MM-DD');
	if (isVorlage) {
		schicht.Titel = document.getElementById('input-vorlage-titel').value;
	} else {
		schicht.Titel = document.getElementById('input-schicht-titel').value;
	}
	// Falls kein Titel angegeben wurde, legen wir einen Standardtitel fest.
	if (schicht.Titel === '') {
		schicht.Titel = 'unbenannt';
	}
	return schicht;
}

/**
 * Speichert eine Schichtvorlage
 * @param {object} schicht SchichtObjekt aus dem Schicht Editor
 */
 async function speichereSchichtVorlage(schicht) {
	// Klone die Schicht damit dessen Inhalt nicht versehentlich überschrieben wird
	let schichtClone = JSON.parse(JSON.stringify(schicht));
	schichtClone = sammleSchichtDaten(schichtClone, true);
	if (schichtClone.Titel === '') {
		zeigeKleineNachricht('Bitte geben Sie noch einen Titel für die Vorlage ein!', 0);
		return;
	}
    // Wir übernehmen die SchichtID der ausgewählten Schichtvorlage
	schichtClone._id = document.querySelector('#input-vorlage').value;
   	schichtClone.ZeitTyp = 8;
	// MitarbeiterID, PostenID und QualifikationID brauchen wir nicht
	schichtClone.MitarbeiterID = '';
	schichtClone.QualifikationID = '';
	schichtClone.Qualifikation = '';
	schichtClone.Posten = '';
	schichtClone.PostenID = '';
	// ... BetriebsstätteID schon
	schichtClone.BetriebsstaetteID = stammdatenService.aktuelleBetriebsstaette;
	const vorlageNeu = await schichtenService.speichereSchichtVorlage(schichtClone);
	if (vorlageNeu !== false) {
		await erstelleToolbarVorlagenSelect();
	}
	closeModal();
}

/**
 * Aktuell ausgewählte Schichtvorlage soll gelöscht werden.
 */
async function loescheSchichtVorlage() {
    const vorlageID = document.querySelector('#input-vorlage').value;
    // Nichts löschen, falls keine ausgewählt ist.
    if (vorlageID === '') return;
    const result = await schichtenService.entferneSchichtObjekt(vorlageID);
    if (result) {
		const select = document.getElementById('vorlage-tb-select');
		select.options[vorlageID].remove();
		document.querySelector(`.vorlagen-liste-item[aria-label="${vorlageID}"]`)?.remove();
    }
	closeModal();
}

export {
    erstelleSchichtInputFeld,
    sammleSchichtDaten,
    speichereSchichtVorlage,
    updateSchichtHandler,
    loescheSchichtVorlage,
};
